import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const getKioskById = (id,sta) => {
    const token=getTokenfromUserObj();
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const getKiosk = async (id) => {
          try {
            console.log(id)
            const res = await axios.get(`${app.URL}/kiosk/view/${id}`,{headers:{auth:token}});
           if(res?.status==200){
             console.log("success", res)
            console.log(res)
            console.log(res?.data);
            setLoading(false);
             setResponse(res?.data);
        sta(res?.data?.data?.mechanism)
           } 
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getKiosk(reqid);
      }, [reqid]);
    
      return { loading, response, error };
    };
export default getKioskById